import { updateAdminAccountSecurity } from 'api/adminAccounts';
import type { TUpdateAdminAccountSecurityRequest } from 'types';

import {
  useUpdateAdminAccountBase,
  type UseUpdateAdminAccountResult,
  type UseUpdateAdminAccountOptions,
} from './useUpdateAdminAccountBase';

export function useUpdateAdminAccountSecurity(
  options: UseUpdateAdminAccountOptions = {},
): UseUpdateAdminAccountResult<TUpdateAdminAccountSecurityRequest> {
  return useUpdateAdminAccountBase<TUpdateAdminAccountSecurityRequest>(
    updateAdminAccountSecurity,
    options,
  );
}
